import { ITextAreaStyle, TextAlignKinds } from "../../../../../../../base/domain/drawing";
import { ITextDrawableObject } from "../../../../../../domain/editableFormat/objects";
import { IObjectBeanTextDrawable } from "../../../beans/objects";
import { IntegerTranslator, ColorCodeTranslator } from "../../values";

export class TextAreaStyleTranslator {
  from(bean: IObjectBeanTextDrawable): ITextAreaStyle {
    return {
      fontStyle: {
        color: {
          value: this.colorCode.from(bean["@fg"]),
        },
        font: {
          family: !bean["@font-name"] ? "Monospaced" : bean["@font-name"],
          size: this.integer.from(bean["@font"]),
        },
      },
      paintStyle: {
        isEnable: !!bean["@bg"],
        color: {
          value: this.colorCode.from(bean["@bg"]),
        },
      },
      alignment: this.horizontal.from(bean["@pos"]) | this.vertical.from(bean["@vpos"]),
    };
  }

  to(object: ITextDrawableObject) {
    return {
      fg: this.colorCode.to(object.textStyle.fontStyle.color.value),
      fontName: (object.textStyle.fontStyle.font.family === "Monospaced") ? undefined : object.textStyle.fontStyle.font.family,
      font: this.integer.to(object.textStyle.fontStyle.font.size) + ".0", // v1の出力形式に合わせる.
      bg: object.textStyle.paintStyle.isEnable
        ? this.colorCode.to(object.textStyle.paintStyle.color.value)
        : undefined,
      pos: this.horizontal.to(object.textStyle.alignment),
      vpos: this.vertical.to(object.textStyle.alignment),
    };
  }
 
  private readonly integer = new IntegerTranslator();
  private readonly colorCode = new ColorCodeTranslator();
  private readonly horizontal = {
    from: (b: string) => (b === "1") ? TextAlignKinds.Left : ((b === "2") ? TextAlignKinds.Center : TextAlignKinds.Right),
    to: (a: TextAlignKinds) => ((a & TextAlignKinds.Left) === TextAlignKinds.Left) ? "1" : (((a & TextAlignKinds.Center) === TextAlignKinds.Center) ? "2" : "3"),
  };
  private readonly vertical = {
    from: (b: string) => (b === "1") ? TextAlignKinds.Top : ((b === "2") ? TextAlignKinds.Middle : TextAlignKinds.Bottom),
    to: (a: TextAlignKinds) => ((a & TextAlignKinds.Top) === TextAlignKinds.Top) ? "1" : (((a & TextAlignKinds.Middle) === TextAlignKinds.Middle) ? "2" : "3"),
  };
}
